var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7606 13.9361H23.3059C23.4933 14.5949 23.5938 15.2901 23.5938 16.0082C23.5938 17.8741 22.9158 19.5842 21.7935 20.9071C21.3694 19.1409 20.1551 17.6784 18.5463 16.9153C19.1993 16.2633 19.6039 15.3628 19.6039 14.3697C19.6039 12.3844 17.9871 10.7694 16 10.7694C14.0129 10.7694 12.3961 12.3844 12.3961 14.3697C12.3961 15.3628 12.8007 16.2633 13.4537 16.9153C11.8449 17.6784 10.6306 19.1406 10.2065 20.9071C9.08425 19.5844 8.40618 17.8741 8.40618 16.0082C8.40618 11.8249 11.8128 8.42161 16 8.42161C16.7317 8.42161 17.4393 8.52583 18.1093 8.71966V7.26414C17.4265 7.10103 16.7198 7.01651 16 7.01651C13.596 7.01651 11.3358 7.95197 9.63595 9.65025C7.93611 11.3485 7 13.6065 7 16.0082C7 18.41 7.93611 20.668 9.63595 22.3665C11.3358 24.0647 13.596 25 16 25C18.404 25 20.664 24.0647 22.3638 22.3665C24.0639 20.668 25 18.41 25 16.0082C25 15.3014 24.9184 14.6074 24.7606 13.9361ZM14.0245 14.3697C14.0245 13.2815 14.9108 12.396 16 12.396C17.0892 12.396 17.9755 13.2815 17.9755 14.3697C17.9755 15.4581 17.0892 16.3434 16 16.3434C14.9108 16.3434 14.0245 15.4581 14.0245 14.3697ZM11.6723 22.2387C11.703 19.8799 13.6318 17.9703 16 17.9703C18.3679 17.9703 20.297 19.8799 20.3277 22.2387C19.099 23.0933 17.6072 23.5951 16 23.5951C14.3928 23.5951 12.901 23.0933 11.6723 22.2387Z",
    fill: "url(#paint0_linear_13_1731)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0301 12.6971L21.9167 11.7258L23.8033 12.6971L23.4427 10.6374L24.9858 9.16431L22.8547 8.86097L21.9167 7L20.9789 8.86118L18.8478 9.16431L20.3909 10.6374L20.0301 12.6971Z",
    fill: "url(#paint1_linear_13_1731)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_1731",
    x1: 16,
    y1: 7.01651,
    x2: 16,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49E2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09BE81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1731",
    x1: 21.9168,
    y1: 7,
    x2: 21.9168,
    y2: 12.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49E2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09BE81"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelections);
export default __webpack_public_path__ + "static/media/selections.e3806a7af4c9de7aa203ecc7f714bd85.svg";
export { ForwardRef as ReactComponent };